// extracted by mini-css-extract-plugin
export default {"tooltip":"AV-z","arrow":"BV-z"};